// Central brand configuration for 90 Brokers Srls
export const BRAND = {
  name: "90 Brokers Srls",
  shortName: "90 Brokers",
  tagline: "Consulenza assicurativa indipendente",
  phone: "340 241 2685",
  phoneRaw: "+393402412685",
  whatsapp: "https://wa.me/393402412685?text=Ciao%2090%20Brokers%2C%20vorrei%20ricevere%20una%20consulenza%20assicurativa.",
  email: "assicurazioni@90brokersrls.it",
  // Reclami / IVASS-compliant contacts
  pec: "90brokerssrls@pec.it",
  vatNumber: "03105620607",
  rui: "B000653996",
  manager: { name: "Adriano Tofani", rui: "B000507116" },
  ruiVerifyUrl: "https://ruipubblico.ivass.it/rui-pubblica/ng/#/workspace/registro-unico-intermediari",
  complaintsPhone: "0775 963312",
  complaintsPhoneRaw: "+390775963312",
  hours: {
    weekdays: "Lun – Ven · 9:00 – 13:00 / 15:30 – 19:30",
    saturday: "Sabato · 9:00 – 13:00",
    short: "Lun–Ven 9–13 · 15:30–19:30",
  },
  address: {
    street: "Via Piave 67",
    city: "Frosinone",
    full: "Via Piave 67, 03100 Frosinone (FR)",
  },
  logo: "https://customer-assets.emergentagent.com/job_0562a2e4-7dd8-4d06-a27c-94f5cd8d3623/artifacts/zcw1wzjb_logo%2090.png",
  social: [
    {
      network: "Instagram",
      handle: "@90brokers.assicurazioni",
      url: "https://instagram.com/90brokers.assicurazioni",
    },
    {
      network: "Facebook",
      handle: "90brokers.assicurazioni",
      url: "https://facebook.com/90brokers.assicurazioni",
    },
    {
      network: "Instagram",
      handle: "@90brokers.energia",
      url: "https://instagram.com/90brokers.energia",
    },
  ],
};

export const NAV_ITEMS = [
  { to: "/", label: "Home" },
  { to: "/chi-siamo", label: "Chi siamo" },
  { to: "/servizi", label: "Servizi" },
  { to: "/come-funziona", label: "Come funziona" },
  { to: "/supporto", label: "Supporto" },
  { to: "/reclami", label: "Reclami" },
  { to: "/contatti", label: "Contatti" },
];

// Documenti aziendali ufficiali
export const DOCUMENTS = [
  {
    id: "mup",
    title: "MUP",
    subtitle: "Modulo Unico Precontrattuale",
    description:
      "Informativa precontrattuale obbligatoria che il broker assicurativo è tenuto a consegnare al cliente.",
    url: "https://customer-assets.emergentagent.com/job_brokers-consultancy/artifacts/3roox1ry_MUP_90BROKERS.pdf",
    size: "PDF",
  },
  {
    id: "mandato",
    title: "Mandato di Brokeraggio",
    subtitle: "Conferimento incarico",
    description:
      "Modulo per il conferimento del mandato di brokeraggio assicurativo a 90 Brokers Srls.",
    url: "https://customer-assets.emergentagent.com/job_brokers-consultancy/artifacts/ldbc9leh_MandatodiBrokeraggio_90Brokers.pdf",
    size: "PDF",
  },
  {
    id: "collaborazioni",
    title: "Collaborazioni Orizzontali",
    subtitle: "Trasparenza intermediari",
    description:
      "Elenco e informativa sulle collaborazioni orizzontali tra intermediari assicurativi ai sensi della normativa IVASS.",
    url: "https://customer-assets.emergentagent.com/job_brokers-consultancy/artifacts/6mop4jj1_Collaborazioni%20Orizzontali.pdf",
    size: "PDF",
  },
  {
    id: "privacy",
    title: "Informativa Privacy",
    subtitle: "Trattamento dati GDPR",
    description:
      "Informativa sul trattamento dei dati personali ai sensi del Regolamento UE 2016/679 (GDPR).",
    url: "https://customer-assets.emergentagent.com/job_brokers-consultancy/artifacts/7fmkv2kp_Privacy.pdf",
    size: "PDF",
  },
  {
    id: "ivass",
    title: "Documentazione IVASS",
    subtitle: "Registro Unico Intermediari",
    description:
      "Consulta il portale ufficiale IVASS — Istituto per la Vigilanza sulle Assicurazioni.",
    url: "https://www.ivass.it/",
    external: true,
    size: "Link esterno",
  },
];

// Compagnie con cui la società di brokeraggio collabora (slider Home)

// Services: only title + short description. No feature/coverage lists.
export const SERVICES = [
  {
    id: "rc-auto",
    title: "RC Auto",
    short: "Polizze per auto, moto e veicoli commerciali",
    description:
      "Confrontiamo le migliori compagnie per offrirti la copertura auto più adatta al tuo profilo di guida, con tariffe ottimizzate.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/0562a2e4-7dd8-4d06-a27c-94f5cd8d3623/images/05ba81dd29c654bbd1c54dc4bbda2e1a18651989be1fc66cee701245684a0c17.png",
    icon: "Car",
  },
  {
    id: "casa",
    title: "Assicurazione Casa",
    short: "Protezione completa della tua abitazione",
    description:
      "Proteggiamo la tua casa con soluzioni modulari pensate sia per proprietari sia per affittuari.",
    image:
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    icon: "Home",
  },
  {
    id: "vita",
    title: "Assicurazione Vita",
    short: "Sicurezza economica per te e la tua famiglia",
    description:
      "Soluzioni di protezione e risparmio a lungo termine per pianificare con serenità il futuro.",
    image:
      "https://images.unsplash.com/photo-1518495973542-4542c06a5843?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    icon: "HeartPulse",
  },
  {
    id: "salute",
    title: "Assicurazione Salute",
    short: "Cure e prevenzione senza compromessi",
    description:
      "Rimborso spese mediche, accesso a strutture convenzionate e prevenzione, in Italia e all'estero.",
    image:
      "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    icon: "Stethoscope",
  },
  {
    id: "aziende",
    title: "Soluzioni Aziende",
    short: "Protezione su misura per professionisti e imprese",
    description:
      "Consulenza dedicata alle partite IVA e alle PMI per la tutela di rischi operativi e patrimonio aziendale.",
    image:
      "https://images.unsplash.com/photo-1767194772164-2c9f20c2c7a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBvZmZpY2UlMjBidWlsZGluZyUyMG1pbGFufGVufDB8fHx8MTc3NzY1ODQ0Mnww&ixlib=rb-4.1.0&q=85",
    icon: "Building2",
  },
  {
    id: "trasporto",
    title: "Trasporto",
    short: "Coperture dedicate al settore autotrasporto",
    description:
      "Soluzioni assicurative specialistiche per autotrasportatori e flotte: dal mezzo alla merce trasportata, fino alla tutela legale e alla capacità finanziaria.",
    image:
      "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    icon: "Truck",
    features: [
      "RCA — Responsabilità civile auto",
      "Incendio · Furto · Kasko",
      "Merce e danni per conto (RCV)",
      "RCT/O — Responsabilità civile terzi e operatori",
      "Soccorso stradale",
      "Assistenza legale",
      "Capacità finanziaria",
    ],
  },
  {
    id: "energia",
    title: "Energia",
    short: "Confronto bollette luce e gas — risparmia subito",
    description:
      "Carica la tua bolletta e ricevi un preventivo personalizzato sulle migliori offerte luce e gas del mercato. Analisi gratuita e senza impegno.",
    image:
      "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    icon: "Zap",
    energiaForm: true,
  },
];

// Insurance companies we work with — used in the marquee slider on Home page
// Insurance companies we work with — used in the marquee slider on Home page.
// `direct: true` means we have a direct mandate; otherwise the partnership is via
// "Collaborazioni Orizzontali" (horizontal collaboration between brokers).
export const COMPANIES = [
  { name: "Generali", id: "generali" },
  { name: "Unipol", id: "unipol" },
  { name: "Allianz", id: "allianz" },
  { name: "AXA", id: "axa" },
  { name: "Reale Mutua", id: "reale-mutua" },
  { name: "Italiana", id: "italiana" },
  { name: "Cattolica", id: "cattolica" },
  { name: "Groupama", id: "groupama" },
  { name: "HDI", id: "hdi" },
  { name: "Wakam", id: "wakam" },
  { name: "ITAS", id: "itas" },
  { name: "Verti", id: "verti" },
  { name: "Prima", id: "prima", direct: true },
  { name: "Linear", id: "linear", direct: true },
  { name: "Genial", id: "genial", direct: true },
];

export const ADVANTAGES = [
  {
    id: "indipendenza",
    title: "Indipendenza totale",
    body: "Non siamo legati ad alcuna compagnia. Lavoriamo solo per te, selezionando le soluzioni più vantaggiose dal mercato assicurativo italiano.",
    icon: "ShieldCheck",
  },
  {
    id: "confronto",
    title: "Confronto tra compagnie",
    body: "Analizziamo decine di preventivi e condizioni per trovare la copertura che offre il miglior equilibrio tra prezzo, garanzie e servizio.",
    icon: "Scale",
  },
  {
    id: "personalizzata",
    title: "Consulenza personalizzata",
    body: "Ogni profilo è unico. Studiamo con te esigenze, abitudini e patrimonio per costruire la polizza realmente adatta alla tua vita.",
    icon: "UserCheck",
  },
  {
    id: "costi",
    title: "Ottimizzazione dei costi",
    body: "Eliminiamo le coperture inutili e negoziamo tariffe competitive: la tua tutela si rafforza, la spesa annuale si riduce.",
    icon: "TrendingDown",
  },
];
